import { Helmet } from "react-helmet-async";
import React,{ useMemo,useState,useEffect} from "react";
import { useDispatch,useSelector } from "react-redux";

import HomePageRows from "../component/HomePageRows/HomePageRows.js";
import { useGetAllConfQuery } from "../services/modules/conf/index"
import { setConf,selectVar } from "../store/conf/confSlice.js";


function Home() {
  const dispatch = useDispatch();
  const bkgCategorie = useSelector(selectVar("_BKG_CATEGORIE", "DEFAULT"));

  console.log ("bkgCategorie",bkgCategorie)
  const { data: confResp,isLoading,isSuccess,refetch } = useGetAllConfQuery();
  const variables = useMemo(() => confResp?.data?.result ?? [],[confResp]);
 
  useEffect(() => {
    if (isSuccess) dispatch(setConf(variables));
  },[isSuccess,variables,dispatch]);
  return (
    <>
      {/* Meta data */}
      {/* <Helmet>
        <title>MyTv</title>
        <meta name="description" content="Explore Movies." />
        <meta name="keywords" content="Movies" />
        <meta name="robots" content="index,follow" />
      </Helmet> */}

      <HomePageRows />

    </>
  );
}

export default Home;
